'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFindReplace = function MdFindReplace(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.7 25.2l8.1 8.2-2.4 2.4-8.2-8.1c-1.9 1.4-4.3 2.3-6.8 2.3-3.2 0-6.2-1.3-8.3-3.4l-3.5 3.4v-10h10l-4.2 4.2c1.5 1.5 3.7 2.4 6 2.4 4 0 7.3-2.8 8.1-6.6h3.3c-0.2 2-1 3.8-2.1 5.2z m-9.3-15.2c-4.1 0-7.5 2.8-8.2 6.6h-3.4c0.8-5.6 5.7-10 11.6-10 3.2 0 6.1 1.4 8.2 3.5l3.4-3.5v10h-10l4.2-4.2c-1.5-1.5-3.6-2.4-5.8-2.4z' })
        )
    );
};

exports.default = MdFindReplace;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/find-replace.js
// module id = 1465
// module chunks = 168707334958949